import { asArray } from "ol/color";
import VectorTileLayer from "ol/layer/VectorTile";
import WebGLVectorTileLayerRenderer from "ol/renderer/webgl/VectorTileLayer";
import {packColor, parseLiteralStyle} from 'ol/webgl/styleparser.js';

const result:any = parseLiteralStyle({
  'fill-color': ['get', 'fillColor'],
  'stroke-color': ['get', 'strokeColor'],
  'stroke-width': ['get', 'strokeWidth'],
  'circle-radius': ['get', 'size'],
  'circle-fill-color': ['get', 'fillColor'],
});


export default class WebGLVectorTileLayer extends VectorTileLayer {
    public mapservice?:any;

    createRenderer():any {
      let self:any=this;
      const getMainStyle = (feature:any) => {
        const styles = self.getStyle()(feature, self.mapservice.view.getResolution());
        return styles?.length ? styles[styles.length - 1] : undefined;
      };
      return new WebGLVectorTileLayerRenderer(self, {
        style: {
          builder: result.builder,
          attributes: {
            fillColor: {
              size: 2,
              callback: (feature) => {
                const s = getMainStyle(feature);
                if(s){
                  const color = asArray(s?.getFill()?.getColor() || '#eee');
                  return packColor(color);
                }
                else{
                  console.log("error for :"+feature)
                  return packColor('#eee');
                }
                
              },
            },
            strokeColor: {
              size: 2,
              callback: (feature) => {
                const s = getMainStyle(feature);
                if(s){
                  const color = asArray(s?.getStroke()?.getColor() || '#eee');
                  return packColor(color);
                }
                else{
                  console.log("error for :"+feature)
                  return packColor('#eee');
                }
              },
            },
            strokeWidth: {
              size: 1,
              callback: (feature) => {
                const s = getMainStyle(feature);
                if(s){
                  return s?.getStroke()?.getWidth() || 0;
                }
                else{
                  console.log("error for :"+feature)
                  return 0;
                }
              },
            },
            size: {
              size: 1,
              callback: (feature) => {
                const s = getMainStyle(feature);
                if(s){
                  if(s?.getImage()!=null){
                    return s?.getImage().getRadius();
                  }else{
                    return 0;
                  }
                  
                }
                else{
                  console.log("error for :"+feature)
                  return 0;
                }
              },
            },
          },
        },
      });
    }
  }
